module.exports = __webpack_public_path__ + "static/media/the-lab-logo-white.c5e9af2c.svg";